module.exports = __webpack_public_path__ + "img/copy.a9fc68f0.svg";